import styled from 'styled-components';

type Props = {
  url: string;
};

const VideoContainer = styled.div`
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  @media ${(props) => props.theme.breakpoints.smd} {
    margin-left: ${(props) => props.theme.grid.getGridColumns(-2, 1)};
    margin-right: ${(props) => props.theme.grid.getGridColumns(-2, 1)};
    padding-left: 1px;
    padding-right: 1px;
  }

  > div {
    position: relative;
    padding-top: 56.25%;
    max-height: 720px;
  }
`;

const Video: React.FC<Props> = ({ url }) => {
  return (
    <VideoContainer>
      <div>
        <iframe
          src={url}
          title="YouTube video player"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: '0px',
          }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
    </VideoContainer>
  );
};

export default Video;
